import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AddressByIdPipe} from './address-by-id.pipe';

@NgModule({
  declarations: [
    AddressByIdPipe
  ],
  exports: [
    AddressByIdPipe
  ],
  imports: [
    CommonModule
  ]
})
export class AddressByIdModule {
}
